module.exports = __webpack_public_path__ + "img/Winterbereit.5ae159ea.jpg";